<template>
  <div>
    <job-menu :job="job"></job-menu>

    <div class="my-10 px-4">
      <div class="flex justify-center items-center">
        <h1 class="text-3xl font-bold text-center w-full mb-5 md:mb-0 md:w-auto">
          {{ __('Create order #:id notification', { id: job.id }) }}
        </h1>
      </div>

      <div class="bg-white px-4 py-10 shadow-md mt-10 overflow-x-auto">
        <div class="max-w-5xl mx-auto">
          <h2 class="text-3xl text-gray-800">
            {{ __('Approval request') }}
          </h2>

          <div class="mt-10">
            <h3 class="text-xl font-bold">{{ __('Operations') }}</h3>

            <table class="w-full border-gray-600 border mt-4" aria-describedby="Job operations table">
              <tr class="bg-gray-700 text-gray-100 text-left">
                <th id="operation-checkbox" class="p-2 min-w-12"></th>
                <th id="operation-description" class="p-2 min-w-48 w-full">{{ __('Description') }}</th>
                <th id="operation-price" class="p-2 min-w-40 text-right">{{ __('Price') }}</th>
                <th id="operation-status" class="p-2 min-w-40 text-right">{{ __('Status') }}</th>
              </tr>

              <tr v-for="(operation, index) in form.operations" :key="operation.id" :class="{'bg-gray-300': index%2 === 0}">
                <td class="px-2 py-4 text-right">
                  <input :id="'operation-' + operation.id" v-model="operation.checked" :checked="operation.checked" type="checkbox" class="checkbox"/>
                </td>
                <td class="px-2 py-4">
                  <label class="cursor-pointer leading-tight flex flex-col" :for="'operation-' + operation.id">
                    <div>{{ operation.description }}</div>
                    <div class="italic text-gray-400 text-sm mt-1" v-if="operation.observations">{{ operation.observations }}</div>
                  </label>
                </td>
                <td class="px-2 py-4 text-right">
                  {{ operation.price }}
                </td>
                <td class="px-2 py-4 text-right">
                  <span class="operation-status" :class="operation.status">{{ operation.status_label }}</span>
                </td>
              </tr>
            </table>
          </div>

          <div class="mt-10">
            <h3 class="text-xl font-bold">{{ __('Media') }}</h3>

            <div class="flex flex-wrap -mx-2 mt-2" v-if="form.media">
              <label class="w-1/3 p-2 flex cursor-pointer" v-for="media in form.media" :key="media.id" :class="{'opacity-50 cursor-not-allowed': media.collection_name === 'videos' && !media.processed_at}">
                <input :id="'operation-' + media.id" v-model="media.checked" :checked="media.checked" type="checkbox" class="checkbox mr-2 transform scale-125" :disabled="media.collection_name === 'videos' && !media.processed_at"/>
                <div class="relative w-full">
                  <div class="absolute w-full h-full bg-black opacity-0 hover:opacity-25"></div>
                  <div class="bg-gray-500 text-white text-sm px-2 py-1 absolute bottom-0 left-0 z-10">{{ media.created_at }} <span v-if="media.collection_name === 'videos' && !media.processed_at">- {{ __('processing...') }}</span></div>
                  <img v-if="media.collection_name === 'images'" :src="media.url" alt="" class="inset-0 h-full w-full object-contain bg-black"/>

                  <video v-if="media.collection_name === 'videos'" class="inset-0 h-full w-full object-contain bg-black" controls>
                    <source :src="media.url" type="video/webm">
                    <source :src="media.url_mp4" type="video/mp4">
                  </video>
                </div>
              </label>
            </div>
          </div>

          <div class="mt-10 flex justify-end">
            <button :disabled="!job.permissions.update" class="h-16 flex items-center justify-center text-2xl px-8 min-w-40 py-2 rounded text-white bg-coral-400 hover:bg-coral-300" @click="storeApprovalRequest()">
              {{ __('Send notification') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Layout from '@/Shared/Layout';
import Icon from '@/Shared/Icon';
import Pagination from '@/Shared/Pagination';
import CheckboxField from '@/Shared/CheckboxField';
import JobMenu from '../Jobs/JobMenu';

export default {
  layout: Layout,
  metaInfo() {
    return {
      title: this.__('Create order #:id notification', { id: this.job.id }),
    };
  },
  props: {
    job: Object,
  },
  components: {
    Layout,
    Pagination,
    Icon,
    JobMenu,
    CheckboxField,
  },
  data() {
    return {
      form: {
        operations: [],
        media: [],
      },
    };
  },
  mounted() {
    this.form.operations = this.job.operations;
    this.form.media = this.job.media;
  },
  methods: {
    storeApprovalRequest() {
      if (confirm(this.__('Send notification?'))) {
        this.$inertia.post(this.route('approvalRequests.store', { job: this.job.id }), {
          operations: this.form.operations.filter((operation) => operation.checked).map((operation) => operation.id),
          media: this.form.media.filter((operation) => operation.checked).map((operation) => operation.id),
        });
      }
    },
  },
};
</script>
